import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAllCategory,
  getAllCity,
  getAllCityByStateId,
  getAllCreditRating,
  getAllDiscom,
  getAllEnergyType,
  getAllGridConnection,
  getAllHoldingCompany,
  getAllNationality,
  getAllPoints,
  getAllRegion,
  getAllStateUT,
  getAllVoltage,
  getControlArea,
  getDiscomByStateId,
  getSpecefication,
  getStateByRegionId,
} from "../../Services/ApiCalling/PublicApi";
import { decryptData } from "../../commons/Decode";
import { ErrorMessage } from "../../commons/Toast/ErrorMessage";

export const publicRating = createAsyncThunk("public/rating", async () => {
  try {
    let element = await getAllCreditRating();
    let data = decryptData(element?.data);
    return data;
  } catch (err) {}
});

export const publicEnergyType = createAsyncThunk(
  "public/energy_type",
  async () => {
    try {
      let element = await getAllEnergyType();
      let data = decryptData(element?.data);
      return data;
    } catch (err) {
      ErrorMessage("An error occurred while fetching energy types.");
    }
  }
);

export const publicVoltage = createAsyncThunk("public/voltage", async () => {
  try {
    let element = await getAllVoltage();
    let data = decryptData(element?.data);
    return data;
  } catch (err) {}
});

export const publicRegion = createAsyncThunk("public/region", async () => {
  try {
    let element = await getAllRegion();
    let data = decryptData(element?.data);
    return data;
  } catch (err) {}
});

export const publicHoldingCompany = createAsyncThunk(
  "public/holding_company",
  async () => {
    try {
      let element = await getAllHoldingCompany();
      let data = decryptData(element?.data);
      return data;
    } catch (err) {}
  }
);

export const publicCategory = createAsyncThunk("public/category", async () => {
  try {
    let element = await getAllCategory();
    let data = decryptData(element?.data);
    return data;
  } catch (err) {}
});

export const publicDiscom = createAsyncThunk("public/discom", async () => {
  try {
    let element = await getAllDiscom();
    let data = decryptData(element?.data);
    return data;
  } catch (err) {}
});

export const publicGrid = createAsyncThunk("public/grid", async () => {
  try {
    let element = await getAllGridConnection();
    let data = decryptData(element?.data);
    return data;
  } catch (err) {}
});

export const publicStateUT = createAsyncThunk("public/state_ut", async () => {
  try {
    let element = await getAllStateUT();
    let data = decryptData(element?.data);
    return data;
  } catch (err) {}
});

// export const publicCity = createAsyncThunk("public/city", async () => {
//   try {
//     let element = await getAllCity();
//     let data = decryptData(element?.data);
//     return data;
//   } catch (err) {}
// });

export const publicCityById = createAsyncThunk("public/cityid", async (id) => {
  try {
    let element = await getAllCityByStateId(id);
    let data = decryptData(element?.data);
    return data;
  } catch (err) {}
});

export const publicStateByRegionId = createAsyncThunk(
  "public/region_stateid",
  async (id) => {
    try {
      let element = await getStateByRegionId(id);
      let data = decryptData(element?.data);
      return data;
    } catch (err) {}
  }
);

export const publicDiscomByStateId = createAsyncThunk(
  "public/Discom_id",
  async (id) => {
    try {
      let element = await getDiscomByStateId(id);
      let data = decryptData(element?.data);
      return data;
    } catch (err) {}
  }
);

export const publicPoints = createAsyncThunk("public/points", async () => {
  try {
    let element = await getAllPoints();
    let data = decryptData(element?.data);
    return data;
  } catch (err) {}
});

export const publicNationality = createAsyncThunk(
  "public/nationality",
  async () => {
    try {
      let element = await getAllNationality();
      let data = decryptData(element?.data);
      return data;
    } catch (err) {}
  }
);
export const publicSpecefication = createAsyncThunk(
  "public/specefication",
  async () => {
    try {
      let element = await getSpecefication();
      let data = decryptData(element?.data);
      return data;
    } catch (err) {}
  }
);
export const publicControlArea = createAsyncThunk(
  "public/controlarea",
  async () => {
    try {
      let element = await getControlArea();
      let data = decryptData(element?.data);
      return data;
    } catch (err) {}
  }
);

const publicSlice = createSlice({
  name: "profile",
  initialState: {
    publicRating: null,
    publicEnergyType: null,
    voltage: null,
    region: null,
    holdingCompany: null,
    category: null,
    discom: null,
    grid: null,
    stateUT: null,
    city: null,
    points: null,
    nationality: null,
    specification: null,
    controlArea: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(publicRating.fulfilled, (state, action) => {
        state.publicRating = action.payload;
      })
      .addCase(publicEnergyType.fulfilled, (state, action) => {
        state.publicEnergyType = action.payload;
      })
      .addCase(publicVoltage.fulfilled, (state, action) => {
        state.voltage = action.payload;
      })
      .addCase(publicRegion.fulfilled, (state, action) => {
        state.region = action.payload;
      })
      .addCase(publicHoldingCompany.fulfilled, (state, action) => {
        state.holdingCompany = action.payload;
      })
      .addCase(publicCategory.fulfilled, (state, action) => {
        state.category = action.payload;
      })
      .addCase(publicDiscom.fulfilled, (state, action) => {
        state.discom = action.payload;
      })
      .addCase(publicDiscomByStateId.fulfilled, (state, action) => {
        state.discom = action.payload;
      })
      .addCase(publicGrid.fulfilled, (state, action) => {
        state.grid = action.payload;
      })
      .addCase(publicStateUT.fulfilled, (state, action) => {
        state.stateUT = action.payload;
      })
      .addCase(publicStateByRegionId.fulfilled, (state, action) => {
        state.stateUT = action.payload;
      })
      // .addCase(publicCity.fulfilled, (state, action) => {
      //   state.city = action.payload;
      // })
      .addCase(publicCityById.fulfilled, (state, action) => {
        state.city = action.payload;
      })
      .addCase(publicPoints.fulfilled, (state, action) => {
        state.points = action.payload;
      })
      .addCase(publicNationality.fulfilled, (state, action) => {
        state.nationality = action.payload;
      })
      .addCase(publicSpecefication.fulfilled, (state, action) => {
        state.specification = action.payload;
      })
      .addCase(publicControlArea.fulfilled, (state, action) => {
        state.controlArea = action.payload;
      });
  },
});

export default publicSlice.reducer;
